<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="image-container" ref="imageContainer">
      <img alt="visorECE" id="image"
           ref="image"
           :style="imageStyle" :src="'data:image/jpeg;base64,'+listaImagenes[indexImagen].imagenBase64"
           style="height: 68vh !important; background: black; cursor: move;"
           @mousedown.prevent="startDrag"
           @mousemove.prevent="dragImage"
           @mouseup.prevent="endDrag"
           @mouseleave.prevent="endDrag"
           @mouseout.prevent="endDrag"/>
    </div>

    <div class="range-wrapper">
      <div class="select-none">10%</div>
      <div class="range-container">
        <div class="left"></div>
        <div class="knob" id="knob"  @pointerdown.prevent="mouseDownHandler($event)"></div>
        <div class="right"></div>
      </div>
      <div class="select-none">200%</div>
      <em class="flecha_anterior_svg primary sm ml-5 mr-1 ml-2" @click="siguienteAnterior"></em>
       {{indexImagen+1}} / {{listaImagenes.length}}
      <em class="flecha_siguiente_svg primary sm ml-1" @click="siguienteImagen"></em>
    </div>
  </div>
</template>

<script>
export default {
  name: "VisorImagenesECE",
  props: {
    listaImagenes: Array,
    index: Number
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      image: null,
      knob: null,
      leftSide: null,
      rightSide: null,
      x : 0,
      y : 0,
      leftWidth : 0,
      minScale : 0.1,
      maxScale : 2,
      step : null,
      indexImagen:0,
      isDragging: false,
      initialMouseX: 0,
      initialMouseY: 0,
      initialImageX: 0,
      initialImageY: 0,
      imageStyle: {
        transform: 'translate(0, 0)',
      },
      escalaImg: ''
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.indexImagen = this.index;
  },
  computed: {
    permitirMovimiento() {
      if (this.image !== null) {
        let scala = this.escalaImg.match(/scale\(([^,]+), ([^)]+)\)/);
        if (parseFloat(scala[1]) > 1 && parseFloat(scala[2]) > 1) {
          return true;
        }
      }

      return false;
    }
  },
  methods: {
    mouseDownHandler(e){
      e.stopPropagation();
      this.image = document.getElementById('image');
      this.knob = document.getElementById('knob');
      this.leftSide = this.knob.previousElementSibling;
      this.rightSide = this.knob.nextElementSibling;
      this.step = (this.maxScale - this.minScale) / 100;
      this.x = e.clientX;
      this.y = e.clientY;
      this.leftWidth = this.leftSide.getBoundingClientRect().width;
      document.addEventListener('pointermove', this.mouseMoveHandler);
      document.addEventListener('pointerup', this.mouseUpHandler);
    },
    mouseMoveHandler(e){
      e.stopPropagation();
      e.preventDefault();
      const dx = e.clientX - this.x;
      //const dy = e.clientY - this.y;

      const containerWidth = this.knob.parentNode.getBoundingClientRect().width;
      let newLeftWidth = ((this.leftWidth + dx) * 100) / containerWidth;
      newLeftWidth = Math.max(newLeftWidth, 0);
      newLeftWidth = Math.min(newLeftWidth, 100);

      this.leftSide.style.width = newLeftWidth + '%';

      this.leftSide.style.userSelect = 'none';
      this.leftSide.style.pointerEvents = 'none';

      this.rightSide.style.userSelect = 'none';
      this.rightSide.style.pointerEvents = 'none';

      const scale = this.minScale + newLeftWidth * this.step;
      this.image.style.transform = 'scale(' + scale + ', ' + scale + ')';
    },
    mouseUpHandler(){
      this.leftSide.style.removeProperty('user-select');
      this.leftSide.style.removeProperty('pointer-events');

      this.rightSide.style.removeProperty('user-select');
      this.rightSide.style.removeProperty('pointer-events');

      // Remove the handlers of mousemove and mouseup
      document.removeEventListener('pointermove', this.mouseMoveHandler);
      document.removeEventListener('pointerup', this.mouseUpHandler);
      this.escalaImg = this.image.style.transform
    },
    siguienteImagen(){
      if(this.listaImagenes.length -1 > this.indexImagen){
        this.indexImagen++;
      }
    },
    siguienteAnterior(){
      if(this.indexImagen > 0){
        this.indexImagen--;
      }
    },
    startDrag(event) {
      if (!this.permitirMovimiento) return;

      this.isDragging = true;
      this.initialMouseX = event.clientX;
      this.initialMouseY = event.clientY;
      this.initialImageX = this.$refs.imageContainer.scrollLeft;
      this.initialImageY = this.$refs.imageContainer.scrollTop;

      const transform = this.image.style.transform;
      const match = transform.match(/translate\(([^,]+), ([^,]+)\)/);
      if (match) {
        this.initialImageX = parseFloat(match[1]);
        this.initialImageY = parseFloat(match[2]);
      }
    },
    dragImage(event) {
      if (!this.permitirMovimiento) return;

      if (this.isDragging) {
        const mouseX = event.clientX;
        const mouseY = event.clientY;
        const deltaX = mouseX - this.initialMouseX;
        const deltaY = mouseY - this.initialMouseY;

        this.image.style.transform = `${this.escalaImg} translate(${this.initialImageX + deltaX}px, ${this.initialImageY + deltaY}px)`;
      }
    },
    endDrag() {
      if (!this.permitirMovimiento) return;

      this.isDragging = false;
    },
  }
}
</script>

<style scoped>
.image-container {
  /* Center the image */
  align-items: center;
  display: flex;
  justify-content: center;

  /* Misc */
  border: 1px solid #17A2B8;
  overflow: hidden;
  width: 100%;
}
.range-wrapper {
  /* Center the content */
  align-items: center;
  display: flex;
  justify-content: center;

  /* Misc */
  padding-top: 2rem;
}
.range-container {
  /* Content is centered horizontally */
  align-items: center;
  display: flex;

  /* Size */
  height: 1.5rem;
  width: 16rem;

  /* Misc */
  margin: 0 0.25rem;
}
.left {
  /* Width based on the current value */
  height: 2px;

  /* Colors */
  background-color: rgba(0, 0, 0, 0.3);
}
.knob {
  /* Size */
  height: 1.5rem;
  width: 1.5rem;

  /* Rounded border */
  border-radius: 9999px;

  /* Colors */
  background-color: rgb(93 93 93);
  cursor: pointer;
}
.right {
  /* Take the remaining width */
  flex: 1;
  height: 2px;

  /* Colors */
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
